import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontIcon, Avatar } from 'material-ui';
import { get } from 'lodash';
import { custom } from '../../utils/Api';

const KAvatar = ({
  imgSrc,
  iconName,
  style,
  size,
  dataCy,
  masterId,
}) => {
  const [imageSrc, setImageSrc] = useState(undefined);
  const [hasTried, setHasTried] = useState(false);
  const setImage = async () => {
    // set to undefined while fetching to prevent broken image icon
    setImageSrc(undefined);
    let imageObj;
    if (masterId) {
      imageObj = get(await custom({
        url: `/kjarni/api/v2/EmployeeMasters(${masterId})/Picture`,
        method: 'GET',
      }), 'data');
    }
    if (imageObj) {
      setHasTried(true);
      const extension = imageObj.Extension.substring(1, imageObj.Extension.length);
      setImageSrc(`data:image/${extension};base64, ${imageObj.FileSource}`);
    }
  };

  useEffect(() => {
    if (imgSrc) {
      setImageSrc(imgSrc);
    } else {
      setImage();
    }
    return () => null;
  }, [imgSrc]);

  return (
    <Avatar
      size={size}
      src={imageSrc}
      onError={() => !hasTried && setImage()}
      style={{ objectFit: 'cover', ...style }}
      icon={<FontIcon className="material-icons">{iconName}</FontIcon>}
      data-cy={dataCy}
    />
  );
};

KAvatar.propTypes = {
  iconName: PropTypes.string,
  imgSrc: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.number,
  dataCy: PropTypes.string,
  masterId: PropTypes.number,
};

KAvatar.defaultProps = {
  iconName: 'person',
  size: 70,
};

export default KAvatar;




// WEBPACK FOOTER //
// ./src/components/KJRN/KAvatar.js